module.exports = __webpack_public_path__ + "static/media/gris_acero.d07e1a27.jpg";